import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import { InboundInvoiceApprovalItemPage } from 'pages/inbound/inbound-invoice-approval-item/InboundInvoiceApprovalItemPage';
import { IInboundInvoiceApprovalListPage } from 'pages/inbound/inbound-invoice-approval-list/InboundInvoiceApprovalListPage';
import { InboundItemAssignPage } from 'pages/inbound/inbound-item-assign/InboundItemAssignPage';
import { InboundListPage } from 'pages/inbound/inbound-list/InboundList';
import { InboundItemReceivePage } from 'pages/inbound/inbound-receive-item/InboundItemReceivePage';
import { InboundSummaryPage } from 'pages/inbound/inbound-summary/InboundSummary';

import { INBOUND_ROUTE_ROOT, INBOUND_ROUTES } from './constants';

export const useInboundRouter = (): React.JSX.Element => (
  <>
    <Route
      path={INBOUND_ROUTE_ROOT}
      element={
        <PrivateRoute
          roles={[
            UserRolesEnum.SUPER_ADMIN,
            UserRolesEnum.ADMIN,
            UserRolesEnum.REPLENISH,
          ]}
        />
      }
    >
      <Route path={INBOUND_ROUTES.ASSIGN} element={<InboundItemAssignPage />} />
      <Route path={INBOUND_ROUTES.LIST} element={<InboundListPage />} />
      <Route path={INBOUND_ROUTES.ITEM} element={<InboundItemReceivePage />} />
      <Route path={INBOUND_ROUTES.SUMMARY} element={<InboundSummaryPage />} />
      <Route
        path={INBOUND_ROUTES.INBOUND}
        element={<Navigate to={INBOUND_ROUTES.ASSIGN} />}
      />
    </Route>
    <Route
      path={INBOUND_ROUTE_ROOT}
      element={
        <PrivateRoute
          roles={[
            UserRolesEnum.SUPER_ADMIN,
            UserRolesEnum.ADMIN,
            UserRolesEnum.APJ,
          ]}
        />
      }
    >
      <Route
        path={INBOUND_ROUTES.APPROVAL_LIST}
        element={<IInboundInvoiceApprovalListPage />}
      />
      <Route
        path={INBOUND_ROUTES.APPROVAL}
        element={<InboundInvoiceApprovalItemPage />}
      />
    </Route>
  </>
);
